import { useAuthContext } from "@contexts/authContext"
import useCableContext from "@contexts/cableContext"
import YesOrNo from "@elements/YesOrNo"
import { Toast } from "@base-ui/react"

const HiddenYesOrNo = ({ isOpen, setClosed }) => {
  const { hideSelf, unhideSelf } = useCableContext()
  const { state: authState } = useAuthContext()
  const toastManager = Toast.useToastManager()

  // The timeout is a little hacky, but it prevents the state from changing long enough for the modal to close
  // this way the updated dialog text doesn't display to the user.
  const timeoutFunc = (func) => new Promise((resolve) => {
    setTimeout(() => { func(); resolve(); }, 200)
  })

  const handleHide = (yesOrNo) => {
    if(yesOrNo) {
      const isHidden = authState?.user?.isHidden
      const func = isHidden ? unhideSelf : hideSelf
      timeoutFunc(func).then(() => {
        const text = isHidden ? 'you are no longer hidden' : 'you are hidden'
        toastManager.add({ text })
      })
    }
    setClosed()
  }

  return (
    <YesOrNo
      isOpen={isOpen}
      setClosed={setClosed}
      handleSelect={handleHide}
      title={authState?.user?.isHidden ? 'Unhide yourself?' : 'Hide yourself?'}
      body={authState?.user?.isHidden ? 'Users will be able to see you on the map and grid.' : 'Users will not be able to see you on the map and grid.'}
    />
  )
}

export default HiddenYesOrNo
